const TestListCycleIcon = (props) => (
  <span className="testCasesHierarchicalListCycleIconContainer">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M20.9048 12.5294H23L19.8571 8.29412L16.7143 12.5294H18.8095C18.8095 16.0341 15.9914 18.8824 12.5238 18.8824C11.4657 18.8824 10.46 18.6176 9.59048 18.1412L8.06095 19.6871C9.34952 20.5129 10.879 21 12.5238 21C17.1543 21 20.9048 17.2094 20.9048 12.5294ZM5.19048 11.4706C5.19048 7.96588 8.00857 5.11765 11.4762 5.11765C12.5343 5.11765 13.54 5.38235 14.4095 5.85882L15.939 4.31294C14.6505 3.48706 13.121 3 11.4762 3C6.84571 3 3.09524 6.79059 3.09524 11.4706H0.999998L4.14286 15.7059L7.28571 11.4706H5.19048Z" fill="#2D4356"/>
      <path d="M12 15H9V17H12V15Z" fill="#2D4356"/>
      <path d="M15 11H9V13H15V11Z" fill="#2D4356"/>
      <path d="M15 7H9V9H15V7Z" fill="#2D4356"/>
    </svg>
  </span>
)

export default TestListCycleIcon